import assets from 'xui/assets'

class XSellySound {
  soundBeepShort: HTMLAudioElement
  soundRingSuccess: HTMLAudioElement
  soundRingError: HTMLAudioElement

  constructor() {
    this.soundBeepShort = new Audio(assets.sounds.barcode_sound)
    this.soundRingSuccess = new Audio(assets.sounds.ring_success)
    this.soundRingError = new Audio(assets.sounds.ring_error)
  }

  playSoundBeepShort() {
    this.playSound(this.soundBeepShort)
  }

  playSoundRingSuccess() {
    this.playSound(this.soundRingSuccess)
  }

  playSoundRingError() {
    this.playSound(this.soundRingError)
  }

  private playSound(audio: HTMLAudioElement) {
    try {
      audio.currentTime = 0
      audio.play().catch((err) => {
        console.warn('Audio play error:', err)
      })
    } catch (err) {
      console.warn('Audio playback failed:', err)
    }
  }
}

const xSound = new XSellySound()
export default xSound
